module.exports = __webpack_public_path__ + "static/fipcwhiterabbitmain-acb77f3b3234d4048635ccc73f10f33b.jpeg";